import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import { tags } from "../../../consts/Tags";
import ButtonInput from "../../chapitre2/ordi/ButtonInput";

export default class ButtonQ1 extends ButtonInput {
    constructor(scene, x, y, text, isTrue) {
        super(scene, x, y);
        this.scene = scene;
        scene.add.existing(this);
        this.soundManager = scene.soundManager

        this.true = isTrue;

        this.non = this.scene.add.text(-35, 10, "Non", {
            fontFamily: FONTS.InterRegular,
            fontSize: '16px',
            color: Colors.Text.Black,
        }).setOrigin(1,1)
        this.add(this.non)

        this.input = new ButtonInput(this.scene, 0, 0);
        this.input.setClickFunction( (input) => {
            this.soundManager.playOnce('Button4')
            if(input.selected){
                this.setSelected();
            }else{
                this.setNormal();
            }
        })
        this.add(this.input)

        this.oui = this.scene.add.text(35,10, "Oui", {
            fontFamily: FONTS.InterRegular,
            fontSize: '16px',
            color: Colors.Text.DarkGrey,
        }).setOrigin(0,1)
        this.add(this.oui)

        this.text = this.scene.add.rexTagText(82, -16, text, {
            fontFamily: FONTS.InterMedium,
            fontSize: '22px',
            color: Colors.Text.Black,
            background: 'transparent',
            tags: tags
        }).setOrigin(0, 0)
        this.add(this.text)

        this.setSize(80, this.text.height )
    }

    setNormal(){
        this.non.setColor(Colors.Text.Black);
        this.oui.setColor(Colors.Text.DarkGrey);
    }

    setSelected(){
        this.non.setColor(Colors.Text.DarkGrey);
        this.oui.setColor(Colors.Text.Black);
    }

    setFalse(){
        this.oui.setColor(Colors.Text.Red);
        this.input.setFalse();
        this.text.setColor(Colors.Text.Red);
    }

    setLocked(){
        this.input.disableInteractive();
    }

    isSelected(){
        return this.input.selected;
    }

    isTrue(){  
        return this.true === this.isSelected();
    }
}